import { render, staticRenderFns } from "./PdpBuildABundleCta.vue?vue&type=template&id=159b86c8&scoped=true&"
import script from "./PdpBuildABundleCta.vue?vue&type=script&lang=js&"
export * from "./PdpBuildABundleCta.vue?vue&type=script&lang=js&"
import style0 from "./PdpBuildABundleCta.vue?vue&type=style&index=0&id=159b86c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b86c8",
  null
  
)

export default component.exports